/**
 * EU sticky ATC extras：Klarna / payment_terms 门控的 financing 链接
 * 暴露 window.syncStickyAtcExtras，供 Package picker 与 sticky 吸底调用。
 */
(function () {
  'use strict';

  if (window.__ocMrStickyAtcExtrasBound) return;
  window.__ocMrStickyAtcExtrasBound = true;

  var MONEY_RE =
    /(?:£|€|\$)\s?\d{1,3}(?:[.,]\d{3})*(?:[.,]\d{2})?|\d{1,3}(?:[.,]\d{3})*(?:[.,]\d{2})?\s?(?:£|€|\$)/;

  function collectText(el) {
    if (!el) return '';
    var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (text) return text;
    try {
      if (el.shadowRoot) {
        return (el.shadowRoot.textContent || '').replace(/\s+/g, ' ').trim();
      }
    } catch (e) {
      /* closed shadow */
    }
    return '';
  }

  function hasKlarnaFinancingUi() {
    var placements = document.querySelectorAll('klarna-placement');
    for (var i = 0; i < placements.length; i++) {
      var kp = placements[i];
      var rect = kp.getBoundingClientRect();
      if (rect.height > 8 || rect.width > 8) return true;
      if (collectText(kp).length > 8) return true;
      if (kp.childElementCount > 0) return true;
    }

    var terms = document.querySelectorAll(
      '.shopify-payment-terms, shopify-payment-terms, .installment.caption-large, form.installment'
    );
    for (var j = 0; j < terms.length; j++) {
      var t = collectText(terms[j]);
      if (t.length > 12 && /klarna|payment|pay|finanz|financ|rate|Monat|mois|mese|mes/i.test(t)) {
        return true;
      }
      if (t.length > 12 && MONEY_RE.test(t)) return true;
    }

    return false;
  }

  function extractAmountFromText(text) {
    if (!text) return '';
    // 优先「/mo|/Monat|/mois|/mese|/mes」附近的金额
    var nearMo = text.match(
      /((?:£|€|\$)\s?\d{1,3}(?:[.,]\d{3})*(?:[.,]\d{2})?|\d{1,3}(?:[.,]\d{3})*(?:[.,]\d{2})?\s?(?:£|€|\$))\s*(?:\/?\s*(?:mo|Monat|mois|mese|mes)\b)/i
    );
    if (nearMo) return nearMo[1].replace(/\s+/g, '').trim();

    // 「payments of £X」或「Ab 99 €」
    var ofPay = text.match(
      /(?:payments?\s+of|ab|à\s+partir\s+de|desde|da)\s*((?:£|€|\$)\s?\d{1,3}(?:[.,]\d{3})*(?:[.,]\d{2})?|\d{1,3}(?:[.,]\d{3})*(?:[.,]\d{2})?\s?(?:£|€|\$))/i
    );
    if (ofPay) return ofPay[1].replace(/\s+/g, '').trim();

    var all = text.match(MONEY_RE);
    return all ? all[0].replace(/\s+/g, '').trim() : '';
  }

  function getKlarnaAmountText() {
    var nodes = document.querySelectorAll(
      'klarna-placement, .shopify-payment-terms, shopify-payment-terms, form.installment, .installment.caption-large'
    );
    for (var i = 0; i < nodes.length; i++) {
      var amount = extractAmountFromText(collectText(nodes[i]));
      if (amount) return amount;
    }
    return '';
  }

  function applyTemplate(template, amount) {
    var tpl = template || 'financing at [amount]/mo';
    if (tpl.indexOf('[amount]') !== -1) {
      return tpl.split('[amount]').join(amount);
    }
    return tpl + ' ' + amount;
  }

  function syncStickyFinancingFromKlarna() {
    var links = document.querySelectorAll('[data-sticky-financing]');
    if (!links.length) return;

    var gated = hasKlarnaFinancingUi();
    var amount = gated ? getKlarnaAmountText() : '';

    links.forEach(function (link) {
      var label = link.querySelector('[data-sticky-financing-label]');
      if (!label) return;

      if (gated && amount) {
        var next = applyTemplate(link.getAttribute('data-financing-template') || '', amount);
        if (label.textContent !== next) label.textContent = next;
        if (link.hidden) link.hidden = false;
      } else {
        if (label.textContent !== '') label.textContent = '';
        if (!link.hidden) link.hidden = true;
      }
    });
  }

  // 动态结账按钮可能保留空容器（钱包不可用 / 尚未渲染），
  // 仅靠 :only-child 判断不到，这里按实际渲染尺寸标记「只有 ATC」状态
  function syncStickyPaymentButtonState() {
    var groups = document.querySelectorAll('.add-submit-container .product-form__buttons');
    for (var i = 0; i < groups.length; i++) {
      var group = groups[i];
      var payButton = group.querySelector('.shopify-payment-button');
      var visible = false;

      if (payButton) {
        var rect = payButton.getBoundingClientRect();
        visible = rect.height > 8 && rect.width > 8;
      }

      group.classList.toggle('oc-sticky-atc-solo', !visible);
    }
  }

  function syncStickyAtcExtras() {
    syncStickyFinancingFromKlarna();
    syncStickyPaymentButtonState();
  }

  window.syncStickyAtcExtras = syncStickyAtcExtras;

  function pollKlarnaOnce() {
    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      syncStickyAtcExtras();
      if ((hasKlarnaFinancingUi() && getKlarnaAmountText()) || tries >= 24) {
        window.clearInterval(timer);
      }
    }, 500);
  }

  var resizeTimer = null;
  window.addEventListener('resize', function () {
    if (resizeTimer) window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(syncStickyPaymentButtonState, 200);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      syncStickyAtcExtras();
      pollKlarnaOnce();
    });
  } else {
    syncStickyAtcExtras();
    pollKlarnaOnce();
  }

  document.addEventListener('shopify:section:load', function () {
    syncStickyAtcExtras();
    pollKlarnaOnce();
  });
})();
